var MCN = MCN || {};

(function ($) {
    'use strict';

    MCN.newsletterModal = function (options) {
        var defaults = {
            selectors: {
                parentElem: '#subscribe-modal'
            },
            cookie: {
                name: 'MCN_NewsletterPopup_hidden',
                expiration: ''
            }
        };

        options = $.extend(true, {}, defaults, options);


        /**********************************
         // Declare DOM elements
         **********************************/
        var $parent = $(options.selectors.parentElem);

        /**********************************
         // Helper function to return a jQuery object, which is a child of 'parentElem'
         **********************************/
        function $parentElem(selector) {
            return $(options.selectors.parentElem + ' ' + selector);
        }

        /**********************************
         // Simple constructor
         **********************************/
        function __construct() {
            var cookieValue = Cookies.get(options.cookie.name);

            if ($parent.length > 0) {
                if (cookieValue !== 'true') {

                    $.colorbox({
                        inline: true,
                        href: $parent,
                        open: true,
                        innerWidth: '80%',
                        maxWidth: '800px',
                        innerHeight: '880px',
                        initialHeight: '880px',

                        onComplete: function () {
                            MCN.NewsletterSubmit($parent, function() {
                                Cookies.set(options.cookie.name, true, {expires: options.cookie.expiration});
                            });
                            return false;
                        },
                        onClosed: function () {
                            Cookies.set(options.cookie.name, true, {expires: options.cookie.expiration});
                        }
                    });
                }
            }
        }

        __construct();


        //
        // Make some events accessible from global scope
        //
        return {};
    };
})(jQuery);
